import { FetchError, ResponseError } from '@nexelem/api';
import { displayCustomToast } from '@nexelem/snackbar';
import { QueryCache, QueryClient } from '@tanstack/react-query';
import { t } from 'i18next';
import { ROUTES, getAbsolutePath } from '../routes/config';

export const isConnectionError = (error: Error): boolean => {
  if (error instanceof FetchError) {
    return true;
  }

  if (error instanceof ResponseError && !error.response) {
    return true;
  }

  return false;
};

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      if (error instanceof ResponseError && error.response?.status === 401) {
        window.location.replace(getAbsolutePath(ROUTES.login));
      }
    },
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (isConnectionError(error)) {
          displayCustomToast({
            toastType: 'error',
            message: t('errors.serverConnectionError'),
            id: 'connection-error',
          });
          return true;
        }

        if (error instanceof ResponseError) {
          const status = error.response?.status;
          return status >= 500 && status < 600 && failureCount <= 3;
        }

        return false;
      },
    },
  },
});
